import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/login/login";
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    service: new service(),
    user: {},
    version: {},
  },
  mutations: {
    setUser(state, data) {
      state.user = data;
    },
    setVersion(state, data) {
      state.version = data;
    },
  },
  actions: {
    async userAuthAD(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.loginAD(state.state.user);
          localStorage.setItem("name", response.name);
          localStorage.setItem("operId", response.operId);
          localStorage.setItem("rolId", response.roleId);
          localStorage.setItem("token", response.accessToken);
          localStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("auditRegis", response.auditRegis);
          localStorage.setItem("init", response.paInicioAsegId);
          localStorage.setItem("active2fa", response.active2fa);
          sessionStorage.setItem("order", response.order);
          state.commit("setUser", response);

          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },

    async userAuth(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.loginAuth(
            state.state.user,
          );
          localStorage.setItem("name", response.name);
          localStorage.setItem("operId", response.operId);
          localStorage.setItem("rolId", response.roleId);
          localStorage.setItem("token", response.accessToken);
          localStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("auditRegis", response.auditRegis);
          localStorage.setItem("init", response.paInicioAsegId);
          localStorage.setItem("active2fa", response.active2fa);
          sessionStorage.setItem("order", response.order);
          state.commit("setUser", response);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async userAuthWithOperId(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.loginWithOperId(
            state.state.user,
          );

          localStorage.setItem("name", response.name);
          localStorage.setItem("operId", response.operId);
          localStorage.setItem("token", response.accessToken);
          localStorage.setItem("refreshToken", response.refreshToken);
          localStorage.setItem("auditRegis", response.auditRegis);
          localStorage.setItem("init", response.paInicioAsegId);
          localStorage.setItem("active2fa", response.active2fa);
          sessionStorage.setItem("order", response.order);
          state.commit("setUser", response);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async getAppVersion(state) {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await state.state.service.getAppVersion();
          state.commit("setVersion", response);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async changepass(state, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.changepass(data);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async forgotPass(state) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.state.service.forgotPass(state.state.user);
          state.commit("setUser", item);
          resolve(true);
        } catch (error) {
          reject(error);
        }
      });
    },
    async avtiveTwoFactor({ state }) {
      return new Promise(async (resolve, reject) => {
        try {
          let item = await state.service.avtiveTwoFactor();
          resolve(item);
        } catch (error) {
          reject(error);
        }
      });
    },
    async verifyTwoFactor(state, token) {
      try {
        let item = await state.state.service.verifyTwoFactor(token);
        return item;
      } catch (error) {
        throw error;
      }
    },
    async updateTwoFactor(state, data) {
      return new Promise(async (resolve, reject) => {
        try {
          await state.state.service.updateTwoFactor(data).then(() => {
            localStorage.setItem("active2fa", data);
            resolve(true);
          });
        } catch (error) {
          reject(error);
        }
      });
    },
  },
});
